//{"receivablenet":"51.10","payablenet":"5.00","profit":"46.10","wkstart":"2018-04-02","cumrecnet":51.1,"cumpaynet":1284.81,"cumprofit":-1233.71,"predprofit":"false","holidayprofit":"false"}

import * as React from 'react';
import { Dimensions, StyleSheet, ScrollView, Animated, Switch, LayoutAnimation, RefreshControl } from 'react-native';
import { Spinner, Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Accordion, Card, CardItem, View, H3 } from 'native-base';
import { LineChart, Grid, YAxis, XAxis, Path } from 'react-native-svg-charts';
import { ClipPath, Defs, Rect, Circle, G, Line, Text as SText } from 'react-native-svg';

import PrevTaxYearBox from './prevTaxYearBox';
//import { Transition } from 'react-navigation-fluid-transitions';
//import Modal from 'react-native-modalbox';
import * as scale from 'd3-scale';
import XDate from 'xdate';
import { Platform } from 'react-native-web';
import Modal from '../../components/modal';

const _GBP = function (num, decimals = false) {
	const numDec = decimals ? 2 : 0;
	return num < 0 ? '-£' + (0 - num).toFixed(numDec) : '£' + Number(num).toFixed(numDec);
};

export default class TaxForecast extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = { showCA: true, showDetails: false, hideNotCurrent: false, showHolidaytax: false };
	}

	showDetails(type) {
		//if (this.state.showDetails) return this.hideAll();
		//LayoutAnimation.configureNext(LayoutAnimation.Presets.linear);
		/*this.setState({ showDetails: type }, () => {
			setTimeout(() => {
				//LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
				this.setState({ hideNotCurrent: true });
			}, 500);
		});*/
		console.log(type);
		this.setState({ showDetails: type });
	}

	hideAll() {
		LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
		this.setState({ showDetails: false });
	}

	currency(val, dec = true) {
		if (typeof val != 'number') return '';
		const numDec = dec ? 2 : 0;
		return val < 0 ? '- £' + Math.abs(val).toFixed(numDec) : '£' + val.toFixed(numDec);
	}

	lineChart(weeklyData, showCA, currTax) {
		//const data = [50, 10, 40, 95, -4, -24, 85, 91, 35, 53, -53, 24, 50, -20, 50];
		weeklyData = weeklyData.map(p => {
			p.wkdate = new Date(p.wkstart);
			return p;
		});
		//profit.pop();
		const lastWeek = weeklyData.length - 1;
		//profit.push(weeklyData[lastWeek].predprofit);

		//const allYs = [...profit, weeklyData[lastWeek].holidayprofit, weeklyData[lastWeek].predprofit]; //full bandwidth of Y axis
		const labels = weeklyData.map(p => p.wkstart);
		const xAxisHeight = 35;
		const chartHeight = 130;
		const numTicks = Math.min(12, weeklyData.length);
		const indexToClipFrom = lastWeek - 1;
		const currProfitY = showCA ? weeklyData[indexToClipFrom].cumprofitmincaps : weeklyData[indexToClipFrom].cumprofit;
		const endY = showCA ? weeklyData[lastWeek].cumprofitmincaps : weeklyData[lastWeek].cumprofit;
		//console.log(endY, currProfitY);

		const Clips = ({ x, width }) => (
			<Defs key={'clips'}>
				<ClipPath id="clip-path-1">
					<Rect x={'0'} y={'0'} width={x(weeklyData[indexToClipFrom].wkdate)} height={'100%'} />
				</ClipPath>
				<ClipPath id={'clip-path-2'}>
					<Rect x={x(weeklyData[indexToClipFrom].wkdate)} y={'0'} width={width - x(weeklyData[indexToClipFrom].wkdate)} height={'100%'} stroke="blue" />
				</ClipPath>
			</Defs>
		);

		const DashedLine = ({ line }) => <Path key={'line-1'} d={line} stroke={'#6487ca'} strokeWidth={3} fill={'none'} strokeDasharray={[4, 4]} clipPath={'url(#clip-path-2)'} />;
		const Shadow = ({ line }) => <Path y={3} key={'shadow-1'} animate={Platform.OS != 'web'} d={line} stroke={'rgba(134, 65, 244, 0.2)'} strokeWidth={5} fill={'none'} />;

		//earn no more
		const DashedhorizLine = ({ x, y }) => (
			<Line
				x1={x(weeklyData[indexToClipFrom].wkdate)}
				x2={x(weeklyData[lastWeek].wkdate)}
				y1={y(currProfitY)}
				y2={y(currProfitY)}
				stroke={'#45c045'}
				strokeWidth={2}
				fill={'none'}
				strokeDasharray={[2, 3]}
			/>
		);

		const Tooltip = ({ x, y }) => {
			const calloutX = Math.max(0, x(weeklyData[indexToClipFrom].wkdate) - 75 / 2);
			const onGraphX = x(weeklyData[indexToClipFrom].wkdate);
			const diff = calloutX - onGraphX; //should be 37.5
			//console.log(diff);
			return (
				<G x={calloutX} key={'tooltip'} onPress={() => this.showDetails('current')}>
					<G x={0-diff}>
						<Line y1={y(currProfitY) > chartHeight - 50 ? 10 : 50} y2={y(currProfitY)} stroke={'grey'} strokeWidth={2} />
						<Circle cy={y(currProfitY)} r={6} stroke={'rgb(134, 65, 244)'} strokeWidth={2} fill={'rgba(255,255,255,0.3)'} />
					</G>
					<G y={y(currProfitY) > chartHeight - 50 ? 10 : 50}>
						<Rect height={40} width={70} stroke={'grey'} fill={'rgba(255,255,255,0.6)'} ry={10} rx={10} />

						<SText x={70 / 2} dy={10} alignmentBaseline={'middle'} textAnchor={'middle'} stroke={'rgb(134, 65, 244)'} strokeWidth={0.6} fontSize={10}>
							{showCA ? `Profit - CA` : `Profit`}
						</SText>

						<SText x={70 / 2} dy={22} alignmentBaseline={'middle'} textAnchor={'middle'} stroke={'rgb(134, 65, 244)'} strokeWidth={1} fontSize={10}>
							{showCA ? `£${weeklyData[indexToClipFrom].cumprofitmincaps.toFixed(0)}` : `£${weeklyData[indexToClipFrom].cumprofit.toFixed(0)}`}
						</SText>

						<SText x={70 / 2} dy={34} alignmentBaseline={'middle'} textAnchor={'middle'} stroke={'rgb(134, 65, 244)'} strokeWidth={0.5} fontSize={10}>
							{`Tax ~ £${currTax}`}
						</SText>
					</G>
				</G>
			);
		};
		//https://github.com/JesperLekland/react-native-svg-charts-examples/blob/master/storybook/stories/partial-chart/line-chart.js

		//console.log(labels, weeklyData, indexToClipFrom);
		const verticalContentInset = { top: 2, bottom: 3, right: 0, left: 0 };
		return (
			<View style={{ height: chartHeight, width: '100%', flexDirection: 'row' }}>
				<YAxis
					data={weeklyData}
					yAccessor={({ item }) => item.cumprofit}
					contentInset={verticalContentInset}
					style={{ marginBottom: xAxisHeight, marginLeft: -7 }}
					svg={{
						fill: 'grey',
						fontSize: 8
					}}
					numberOfTicks={8}
					formatLabel={value => _GBP(value) + ' '}
				/>

				<View style={{ flex: 1, marginLeft: 10 }}>
					<LineChart
						xScale={scale.scaleTime}
						animate={Platform.OS != 'web'}
						style={{ flex: 1 }}
						contentInset={verticalContentInset}
						data={weeklyData}
						yAccessor={({ item }) => (showCA ? item.cumprofitmincaps || item.predcapallprofit : item.cumprofit || item.predprofit)}
						xAccessor={({ item }) => item.wkdate}
						svg={{
							stroke: 'rgb(134, 65, 244)',
							clipPath: 'url(#clip-path-1)'
						}}>
						<Grid />
						<Clips />

						<Tooltip />
						<DashedLine />
						<DashedhorizLine />
					</LineChart>
					<XAxis
						style={{ marginHorizontal: -10, height: xAxisHeight }}
						data={weeklyData}
						xAccessor={({ item }) => item.wkdate}
						numberOfTicks={numTicks}
						scale={scale.scaleTime}
						formatLabel={(v, index) => XDate(v).toString('dd/MM/yy')}
						contentInset={{ left: 10, right: 10 }}
						svg={{
							fill: 'grey',
							fontSize: 8,
							fontWeight: 'bold',
							rotation: -45,
							originY: xAxisHeight,
							y: 8
						}}
					/>
				</View>
			</View>
		);
	}

	render() {
		var { height, width } = Dimensions.get('window');
		const { reportData, taxOnly } = this.props;
		const { showCA, showDetails, hideNotCurrent } = this.state;
		//console.log('rendering TaxForecast', reportData, showDetails);
		if (!reportData) return <Spinner style={{ flex: 1 }} />;

		if (taxOnly && reportData.prevYears && reportData.prevYears.length == 1) this.props.navigation.navigate('SaDetails', { year: reportData.prevYears[0].taxyear });
		//figure how many rows we can add
		return (
			<>
				<Modal
					isOpen={!!showDetails}
					backButtonClose
					backdropPressToClose
					coverScreen
					style={{ width: '95%' }}
					backdropColor="#295670"
					onClosed={() => this.setState({ showDetails: false })}
					useNativeDriver>
					{showDetails == 'forecast' && (
						<Card style={[styles.cardRoundTop, { flex: 1, height: '100%' }]} key="card4">
							<CardItem button style={styles.roundTopBlue} onPress={() => this.setState({ showDetails: false })}>
								<View style={{ flex: 1 }}>
									<Text>If I earn at the same rate?</Text>
									<Text note style={styles.subTitle}>
										Your estimated final bill
									</Text>
								</View>
								<View>
									<Text style={styles.moneyTxt}>£{reportData.forecasttax}</Text>
								</View>
							</CardItem>
							<ScrollView style={{ flex: 1 }}>
								{reportData.taxforecasttable.map((row, i) => (
									<CardItem button onPress={() => this.hideAll()} key={i}>
										<View style={{ flex: 2 }}>
											<Text>{row.text}</Text>
											<Text style={{ textAlign: 'right' }}>{row.colone ? '£' + row.colone.toFixed(0) : ''}</Text>
										</View>
										<Text note style={{ textAlign: 'center', flex: 1, alignSelf: 'center' }}>
											{row.coltwo}
										</Text>
										<Right style={{ flex: 1 }}>
											<Text style={{ textAlign: 'right' }}>{row.text ? '£' + row.val.toFixed(0) : ''}</Text>
										</Right>
									</CardItem>
								))}
							</ScrollView>
						</Card>
					)}

					{showDetails == 'holiday' && (
						<Card style={[styles.cardRoundTop, { flex: 1, height: '100%' }]} key="card3">
							<CardItem button style={[styles.roundTopBlue, styles.blue]} onPress={() => this.setState({ showDetails: false })}>
								<View style={{ flex: 1 }}>
									<Text>If I earn no more money this taxyear?</Text>
									<Text note style={styles.subTitle}>
										Running calculation with current figures
									</Text>
								</View>
								<View>
									<Text style={styles.moneyTxt}>£{reportData.holidaytax}</Text>
								</View>
							</CardItem>
							<ScrollView style={{ flex: 1 }}>
								{reportData.taxholidaytable.map((row, i) => (
									<CardItem button onPress={() => this.hideAll()} key={i}>
										<Left style={{ flex: 1 }}>
											<Text>{row.text}</Text>
										</Left>
										<Body style={{ width: 50 }}>
											<Text note>{row.coltwo}</Text>
										</Body>
										<Right style={{ width: 80, alignContent: 'flex-end' }}>
											<Text style={{ textAlign: 'right' }}>£{row.val ? row.val.toFixed(2) : '0'}</Text>
										</Right>
									</CardItem>
								))}
							</ScrollView>
						</Card>
					)}

					{showDetails == 'current' && (
						<Card style={[styles.cardRoundTop, { flex: 1, height: '100%' }]} key="card2">
							<CardItem button style={[styles.roundTopBlue, styles.purple]} onPress={() => this.setState({ showDetails: false })}>
								<View style={{ flex: 1 }}>
									<Text>What should I have saved?</Text>
									<Text note style={styles.subTitle}>
										Spreading things evenly through the year
									</Text>
								</View>
								<View>
									<Text style={styles.moneyTxt}>£{reportData.currenttax}</Text>
								</View>
							</CardItem>
							<ScrollView style={{ flex: 1 }}>
								{reportData.taxcurrenttable.map((row, i) => (
									<CardItem button onPress={() => this.hideAll()} key={i} style={{ marginVertical: 0, borderTopWidth: row.cls ? 1 : 0 }}>
										<View>
											<Text>{row.text}</Text>
											<Text style={{ textAlign: 'right' }}>{row.colone}</Text>
										</View>
										<Text note style={{ textAlign: 'center', flex: 1, alignSelf: 'center' }}>
											{row.coltwo}
										</Text>
										<Right style={{ flex: 1 }}>
											<Text style={{ textAlign: 'right' }}>{this.currency(row.val, false)}</Text>
										</Right>
									</CardItem>
								))}
							</ScrollView>
						</Card>
					)}
				</Modal>
				<Content
					style={{ width: '100%' }}
					scrollable
					ref={ref => (this.scrollView = ref)}
					onContentSizeChange={(contentWidth, contentHeight) => {
						Platform.OS != 'web' && this.scrollView._root.scrollToEnd({ animated: false });
						//console.log(this.scrollView);
					}}
					refreshControl={
						<RefreshControl
							refreshing={this.props.refreshing}
							onRefresh={() => {
								this.props.doRefresh();
							}}
						/>
					}>
					{!taxOnly && (
						<Card style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
							<CardItem style={{ backgroundColor: '#6aa4c8', borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' }}>
								<Left>
									<Icon style={{ color: 'white' }} name="calendar" />
									<Body>
										<Text style={{ color: 'white' }}>{reportData.currentYear}</Text>
									</Body>
								</Left>
							</CardItem>

							<Card style={{ marginTop: 10, width: '99%' }} key="card1">
								<CardItem header style={{ flexDirection: 'column' }}>
									<Text>Your taxable profit</Text>
									{showCA ? <Text note>Includes capital allowances, spread out through the year</Text> : <Text note>Excluding Capital Allowances</Text>}
								</CardItem>
								<CardItem>{reportData.profitByWeek && this.lineChart(reportData.profitByWeek, showCA, reportData.currenttax)}</CardItem>
								<CardItem>
									<Text style={{ flex: 1 }}>Include Capital Allowances</Text>
									<Switch value={showCA} onValueChange={() => this.setState({ showCA: !showCA })} />
								</CardItem>
							</Card>

							<Card style={[styles.cardRoundTop]} key="card2">
								<CardItem button style={[styles.roundTopBlue, styles.purple]} onPress={() => this.showDetails('current')}>
									<View style={{ flex: 1 }}>
										<Text>What should I have saved?</Text>
										<Text note style={styles.subTitle}>
											Spreading things evenly through the year
										</Text>
									</View>
									<View>
										<Text style={styles.moneyTxt}>£{reportData.currenttax}</Text>
									</View>
								</CardItem>
							</Card>

							<Card style={styles.cardRoundTop} key="card3">
								<CardItem button style={[styles.roundTopBlue, styles.blue]} onPress={() => this.showDetails('holiday')}>
									<View style={{ flex: 1 }}>
										<Text>If I earn no more money this taxyear?</Text>
										<Text note style={styles.subTitle}>
											Running calculation with current figures
										</Text>
									</View>
									<View>
										<Text style={styles.moneyTxt}>£{reportData.holidaytax}</Text>
									</View>
								</CardItem>
							</Card>

							<Card style={styles.cardRoundTop} key="card4">
								<CardItem button style={styles.roundTopBlue} onPress={() => this.showDetails('forecast')}>
									<View style={{ flex: 1 }}>
										<Text>If I earn at the same rate?</Text>
										<Text note style={styles.subTitle}>
											Your estimated final bill
										</Text>
									</View>
									<View>
										<Text style={styles.moneyTxt}>£{reportData.forecasttax}</Text>
									</View>
								</CardItem>
							</Card>
						</Card>
					)}
					{taxOnly && <H3 style={{ margin: 10 }}>Please select a year...</H3>}
					{reportData.prevYears && reportData.prevYears.map((y, i) => <PrevTaxYearBox key={i} year={y} navigation={this.props.navigation} taxOnly={taxOnly} />)}
				</Content>
			</>
		);
	}
}

const styles = StyleSheet.create({
	moneyTxt: {
		fontSize: 17,
		fontWeight: 'bold'
	},
	subTitle: {
		color: '#FFF'
	},
	underCard: { alignSelf: 'center', width: '95%', marginHorizontal: 10 },
	cardRoundTop: {
		margin: 0,
		backgroundColor: 'transparent',
		flex: 0,
		alignSelf: 'center',
		width: '95%',
		marginHorizontal: 20,
		flexDirection: 'column',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	},
	roundTopBlue: { backgroundColor: '#6aa4c8', borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' },
	green: { backgroundColor: '#45c045' },
	purple: { backgroundColor: '#b082f9' },
	blue: { backgroundColor: '#6487ca' },
	red: { backgroundColor: '#c04545' }
});
